import dateFormatType from '@/constants/dateFormatType';
import { deliveryChargeTypeName } from '@/constants/storeManagement/deliveryChargeDialog';
import { addComma, deleteComma, } from '@/utils/number';
import { getFormattedDate } from '@/utils/time';
/**
 * 배달대행료
 */
export default class DeliveryCharge {
    _id = -1;
    /** 배달대행료 아이디 */
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    _storeId = '';
    get storeId() {
        return this._storeId;
    }
    set storeId(value) {
        this._storeId = value;
    }
    _type = deliveryChargeTypeName.DISTANCE;
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    _distanceStart = 0;
    get distanceStart() {
        return this._distanceStart;
    }
    set distanceStart(value) {
        this._distanceStart = value;
    }
    _distanceEnd = 0;
    get distanceEnd() {
        return this._distanceEnd;
    }
    set distanceEnd(value) {
        this._distanceEnd = value;
    }
    _businessHourStart = '';
    get businessHourStart() {
        return this._businessHourStart;
    }
    set businessHourStart(value) {
        this._businessHourStart = value;
    }
    _businessHourEnd = '';
    get businessHourEnd() {
        return this._businessHourEnd;
    }
    set businessHourEnd(value) {
        this._businessHourEnd = value;
    }
    _addressJibunStart = 0;
    get addressJibunStart() {
        return this._addressJibunStart;
    }
    set addressJibunStart(value) {
        this._addressJibunStart = value;
    }
    _addressJibunEnd = 0;
    get addressJibunEnd() {
        return this._addressJibunEnd;
    }
    set addressJibunEnd(value) {
        this._addressJibunEnd = value;
    }
    _charge = '0';
    get charge() {
        return addComma(this._charge);
    }
    set charge(value) {
        this._charge = deleteComma(value);
    }
    _surcharge = '0';
    get surcharge() {
        return addComma(this._surcharge);
    }
    set surcharge(value) {
        this._surcharge = deleteComma(value);
    }
    _workingDay = [];
    get workingDay() {
        return this._workingDay;
    }
    set workingDay(value) {
        this._workingDay = value;
    }
    _specialArea = '';
    get specialArea() {
        return this._specialArea;
    }
    set specialArea(value) {
        this._specialArea = value;
    }
    _areaId = -1;
    /** 배대료 구역설정 아이디. 구역 타입이 아니어도 0이 내려온다..! */
    get areaId() {
        return this._areaId;
    }
    set areaId(value) {
        this._areaId = value;
    }
    _areaName = '';
    /** 구역 타입의 경우 구역 이름. 기본값 null 이다. */
    get areaName() {
        return this._areaName;
    }
    set areaName(value) {
        this._areaName = value;
    }
    constructor(_data) {
        if (!_data) {
            return;
        }
        const data = this.translate(_data);
        Object.assign(this, data);
    }
    /**
     * 서버 응답값을 프론트에서 사용할 형태로 번역
     * back -> front
     * @returns
     */
    // eslint-disable-next-line class-methods-use-this
    translate(data) {
        return {
            ...data,
            businessHourStart: getFormattedDate(data.businessHourStart, 'HHmm', dateFormatType.SHORT_TIME),
            businessHourEnd: getFormattedDate(data.businessHourEnd, 'HHmm', dateFormatType.SHORT_TIME),
            charge: String(data.charge),
            surcharge: String(data.surcharge),
        };
    }
}
